import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import api from '@/lib/api';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

        if (!sessionId) {
          navigate('/login', { replace: true });
          return;
        }

        const res = await api.get(`/auth/session?session_id=${sessionId}`);
        login(res.data);
        // Clear hash and navigate to dashboard
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { replace: true, state: { user: res.data } });
      } catch {
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-sand" data-testid="auth-callback">
      <div className="text-center">
        <div className="animate-breathe">
          <div className="w-12 h-12 rounded-full bg-gold/30 mx-auto mb-4" />
        </div>
        <p className="text-text-muted font-sans text-sm tracking-widest uppercase">Aligning your energy...</p>
      </div>
    </div>
  );
}
